<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>

    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row class="table-header-gai">
          <el-col>
            <el-button
              v-if="userPermissions.indexOf('customer_sign') != -1"
              size="medium"
              type="primary"
              class="cusomer-link-gai"
              @click="cusomerLink"
              >任务发布
            </el-button>
          </el-col>
        </el-row>
        <el-row style="height: 36px">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="任务名称">
              <el-input
                v-model="searchCondition.recruit_post"
                placeholder="输入任务名称"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="行业类型">
              <el-cascader
                v-model="searchCondition.industry_type"
                placeholder="请选择行业类型"
                clearable
                filterable
                :options="formList[1].selectOption"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="任务类型">
              <el-select
                v-model="searchCondition.category_id"
                filterable
                clearable
                :multiple-limit="1"
                placeholder="请选择任务类型"
                class="selectWord"
              >
                <el-option
                  v-for="item in categoryList"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
            <div class="table-right">
              <el-form-item>
                <el-select
                  v-model="exportSelect"
                  @change="changeExportOption"
                  class="select-box"
                >
                  <el-option
                    v-for="item in exportOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  :loading="downloadLoading"
                  type="primary"
                  icon="el-icon-document"
                  @click="handleDownload"
                >
                  导出
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-row>

        <!-- 生成签约链接的dialog模态框 -->
        <el-dialog
        v-if="outerVisible"
          title="任务发布"
          :visible.sync="outerVisible"
          :before-close="handleOuterClose"
          width="40%"
        >
          <el-form ref="refForm" size="medium" :inline="true" :model="companyFormData">
            <el-form-item
              v-for="(item, index) in formList"
              :key="index"
              :label="item.label"
              :prop="item.props"
              :required="item.required"
              :rules="[
                {
                  required: item.required,
                  message: '请输入' + item.label,
                  trigger: 'blur',
                },
              ]"
              :show-message="false"
            >
              <template v-if="item.type == 'input'">
                <el-input
                  v-model="companyFormData[item.props]"
                  :placeholder="item.placeholder"
                ></el-input>
              </template>
              <template v-else-if="item.type == 'textarea'">
                <el-input
                  type="textarea"
                  v-model="companyFormData[item.props]"
                ></el-input>
              </template>
              <template v-else-if="item.type == 'picker'">
                <el-select
                  v-model="companyFormData[item.props]"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item1, index1) in item.selectOption"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-else-if="item.type == 'multiplePicker'">
                <el-select
                  v-model="companyFormData[item.props]"
                  placeholder="请选择"
                  clearable
                  filterable
                  multiple
                >
                  <el-option
                    v-for="(item1, index1) in item.selectOption"
                    :key="index1"
                    :label="item1.label"
                    :value="item1.value"
                  ></el-option>
                </el-select>
              </template>
              <template v-else-if="item.type == 'cascader'">
                <el-cascader
                  v-model="companyFormData[item.props]"
                  placeholder="请选择"
                  clearable
                  filterable
                  :options="item.selectOption"
                >
                </el-cascader>
              </template>
            </el-form-item>
            <el-form-item label="请选择任务类型" prop="desc" id="desc">
              <el-checkbox-group
                v-model="companyFormData.name"
                size="small"
                @change="handleTaskChange"
                :max="10"
              >
                <el-checkbox
                  v-for="item in categoryList"
                  :label="item.name"
                  :key="item.id"
                  border
                >
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>

          <el-dialog
            width="40%"
            :title="'系统提示'"
            :close-on-click-modal="false"
            :visible.sync="innerVisible"
            :before-close="handleInnerClose"
            append-to-body
          >
            <div v-if="dialogType == 1">
              <div class="dialog-title">
                <i
                  class="el-icon-success"
                  style="font-size: 40px; color: #409eff"
                ></i>
                <span class="title-text">手机扫一扫，请到手机端分享</span>
              </div>
              <div class="center-box">
                <div class="code">
                  <img
                    :src="this.OrImage"
                    class="QR-code"
                    v-if="this.OrImage"
                  />
                  <div class="tips">
                    打开微信[扫一扫]
                  </div>
                </div>
                <div
                  class="alipay-code code"
                  v-if="this.noaliqrcodeUrl.includes(this.host) == false"
                >
                  <img
                    :src="this.alipayOrImage"
                    class="QR-code"
                    v-if="this.alipayOrImage"
                  />
                  <div class="tips">
                    打开支付宝[扫一扫]
                  </div>
                </div>
              </div>
            </div>
            <div v-if="dialogType == 2">
              <div class="center-box">
                {{ tabContent }}
              </div>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button
                type="primary"
                @click="closeQRDialog"
                size="medium"
                :disabled="isCheck"
                >关闭
              </el-button>
            </div>
          </el-dialog>
          <div
            slot="footer"
            class="dialog-footer"
            style="text-align: center; margin-bottom: 20px"
          >
            <!-- <el-button @click="outerClose" size="medium">取 消</el-button> -->
            <el-button
              type="primary"
              @click="checkCategory"
              size="medium"
              :disabled="isCheck"
              >发布
            </el-button>
          </div>
        </el-dialog>

        <el-dialog
			width="40%"
			:title="'系统提示'"
			:close-on-click-modal="false"
			:visible.sync="qrVisible"
			:before-close="handleQRClose"
			append-to-body
		>
			<div v-if="tabType==1">
				<div class="dialog-title">
					<i
						class="el-icon-success"
						style="font-size: 40px; color: #409eff"
					></i>
					<span class="title-text">手机扫一扫，请到手机端分享</span>
				</div>
				<div class="center-box">
					<img :src="this.OrImage" class="QR-code" v-if="this.OrImage"/>
				</div>
			</div>
			<div v-if="tabType==2">
				<div class="center-box">
					<el-input type="textarea" readonly rows="8" :value="tabContent"></el-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="handleQRClose"
					size="medium">
				关闭
				</el-button>
			</div>
		</el-dialog>

        <el-dialog
          width="40%"
          :title="'系统提示'"
          :close-on-click-modal="true"
          :visible.sync="qzFlag"
          append-to-body
        >
          <div class="dialog-title">
            <i
              class="el-icon-success"
              style="font-size: 40px; color: #409eff"
            ></i>
            <span class="title-text">请用户再次核对手写签章</span>
          </div>
          <div class="center-box">
            <img
              :src="this.OrImage_qz"
              class="QR-code"
              v-if="this.OrImage_qz"
            />
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="qzFlag = false" size="medium"
              >关闭
            </el-button>
          </div>
        </el-dialog>

        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column align="center" label="薪资水平">
            <template slot-scope="scope">
              <div>{{ getSalaryType(scope.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="任务发布时间">
            <template slot-scope="scope">
              <div>{{ scope.row.created_at }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="审核状态">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.examine_status == "1"
                    ? "审核成功"
                    : scope.row.examine_status == "2"
                    ? "审核失败"
                    : "审核中"
                }}
              </div>
              <div
                style="color:#1890ff;cursor: pointer;"
                v-if="scope.row.examine_status == '2'"
                @click="showMissionContent(scope.row.examine_reason)"
              >
                查看失败原因
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <div>{{ scope.row.status | TransactionStatus }}</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="报名审核">
            <template slot-scope="scope">
              <div
                style="color:#1890ff;cursor: pointer;"
                v-if="
                  scope.row.examine_status == '1'"
                  @click="toPersonnellistExamine(scope.row)">
                查看
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="合作邀请码">
            <template slot-scope="scope">
              <div
                style="color:#1890ff;cursor: pointer;"
                v-if="
                  scope.row.examine_status == '1' &&
                    scope.row.status == '1' &&
                    scope.row.code_url
                "
                @click="showMissionCode(scope.row.code_url)"
              >
                查看
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType == 'text'"
            width="160"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  type="infor"
                  size="mini"
                  @click="toCustomer(scope.row)"
                  >查看</el-button
                >
                <el-popover
                  placement="top"
                  v-model="scope.row.visible"
                  v-if="scope.row.examine_status == '1'"
                >
                  <p>确定要修改状态吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="checkUpload(scope.row.status, scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <el-button
                    size="mini"
                    :type="scope.row.status == 1 ? 'danger' : 'primary'"
                    slot="reference"
                    >{{ scope.row.status == 1 ? "关闭" : "开启" }}</el-button
                  >
                </el-popover>
                <el-button type="infor" size="mini" @click="toView(scope.row)"
                  >详情</el-button
                >
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import json from "../../../public/citys.json";
import { gettreeList, getSalaryTypeText } from "@/utils/utils";
//import signCompent from "./sign.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    //signCompent
  },
  data() {
    return {
      tabType:'',
      json,
      qrVisible:false,
      host: window.location.host,
      noaliqrcodeUrl: ["khlztrz.51xinlong.com", "www.ztrztd.com"],
      qyLinkForm: {
        mobile: "",
        url: "",
      },
      is_E_sign: false,
      sign_downloadLoading: false,
      showDesc: false,
      is_show_djg: "",
      dialogPdfArr: [],
      dialogMultPdf: false,
      OrImage_qz: "",
      qzFlag: false,
      checkList: ["选中且禁用", "复选框 A"],
      //选择签约类型
      hidenumber: "****",
      value: "",
      companyFormData: {
        category_id: [],
        name: [],
        missionContent: "",
      },
      categoryList: [],
      signUrl: "", //签约链接
      outerVisible: false, //外层模态框状态
      innerVisible: false, //内层模态框状态
      searchCategory: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      formList: [
        {
          required: true,
          label: "任务名称",
          type: "input",
          props: "recruit_post",
          value: "",
          placeholder: "请输入任务名称",
          disabled: false,
          show: true,
        },
        {
          id: "industry_type",
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "industry_type",
          value: [],
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          id: "work_city",
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value_text_props: "address",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "input",
          props: "address_detail",
          placeholder: "请输入详细地点",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: [
          { label: "日结", value: 1 },
            { label: "周结", value: 2 },
            { label: "月结", value: 3 },
            { label: "次结", value: 4 },
            { label: "完工结", value: 5 },
          ],
          placeholder: "请选择结算方式",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "worked_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          id: "min_salary",
          label: "最低薪资",
          type: "input",
          props: "min_salary",
          placeholder: "请输入最低薪资",
          value: "",
          show: true,
        },
        {
          required: true,
          id: "max_salary",
          label: "最高薪资",
          type: "input",
          props: "max_salary",
          placeholder: "请输入最高薪资",
          value: "",
          show: true,
        },
        {
          required: true,
          id: "education",
          label: "学历要求",
          type: "picker",
          props: "education",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: 1 },
            { label: "初中", value: 2 },
            { label: "高中", value: 3 },
            { label: "大专", value: 4 },
            { label: "本科及以上", value: 5 },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        {
          label: "任务描述",
          type: "textarea",
          props: "job_remark",
          value: "",
          placeholder: "请输入任务描述",
          disabled: false,
          show: true,
        },
      ],
      columns: [
        {
          title: "任务编号",
          value: "id",
          width: 170,
          header_align: "center",
          align: "center",
        },
        {
          title: "任务名称",
          value: "recruit_post",
          header_align: "center",
          align: "center",
        },
        {
          title: "任务类型",
          value: "category_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "行业类型",
          value: "industry_type_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作地点",
          value: "all_address",
          header_align: "center",
          align: "center",
        },
      ],
      // 表格列表数据
      companyList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 添加附件
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      // 附件表单内容
      formData: {},
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
      isCheck: true, //是否禁用确定按钮
      category_Id: "",
      category_name: "",
      id: "",
      OrImage: "",
      alipayOrImage: "",
      is_import: "",
      exportOptions: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      //导出表格类型
      exportType: "xlsx",
      downloadLoading: false,
      exportSelect: "xlsx",
      dialogType: 1,
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    handleQRClose(){
      this.qrVisible = false;
      this.OrImage = "";
    },
    showMissionContent(content){
      this.tabType = 2;
      this.tabContent = content;
      this.qrVisible = true;
    },
    // 开启二维码弹框
    showMissionCode(url){
      this.OrImage = url;
      this.tabType = 1;
      this.qrVisible = true;
    },
    getSalaryType(e) {
      return getSalaryTypeText(e);
    },
    // 跳转详情页面
    toView(row) {
      this.$router.push({ name: "privateTask_view", params: row,query:{task_type:2} });
    },
    toPersonnellistExamine(row){
      this.$router.push({
        path: "/publicTask/personnelList",
        query: { id: row.id, task_type: 2 },
      });
    },
    toCustomer(row) {
      console.log();
      this.$router.push({
        path: "/taskCustomer",
        query: { task_id: row.id, task_type: 2 },
      });
    },
    async checkUpload(status, id) {
      var missionStatus;
      if (status == 1) {
        missionStatus = 0;
      }
      if (status == 0) {
        missionStatus = 1;
      }
      let args = {
        status: missionStatus,
        id,
      };
      let res = await this.$api.closeDailyTask(args);
      if (res) {
        this.init();
      }
    },
    async getDailyTaskIndustryList() {
      let res = await this.$api.getDailyTaskIndustryList();
      this.formList[1].selectOption = gettreeList(
        res,
        "industry_type_name",
        "id"
      );
    },
    async event_searchLink() {
      if (!this.qyLinkForm.mobile) {
        this.$message.warning("请输入手机号");
        return false;
      }
      let args = {
        mobile: this.qyLinkForm.mobile,
      };
      let res = await this.$api.getQyLink(args);
      this.qyLinkForm.url = res.url;
      if (!res.url) {
        this.$message.warning("暂无签约链接");
      }
    },
    changeExportOption(e) {
      this.exportType = e;
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = this.columns.map(item => item.title);
        sHeader.splice(this.columns.length,0,'薪资水平','任务发布时间','审核状态','状态')
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `任务列表${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let tempArr = []
        this.columns.map((item,index)=>{
          tempArr.push(v[item.value])
          if(this.columns.length-1 == index){
            tempArr.splice(this.columns.length,0,this.getSalaryType(v),v.created_at,v.examine_status==1?'审核成功':v.examine_status==2?'审核失败':'审核中',v.status==1?'开启':'关闭')

          }
        })
        return tempArr
      })
    },
    //关闭二维码弹窗
    closeQRDialog() {
      this.outerVisible = false;
      this.innerVisible = false;
      this.companyFormData = {
        category_id: [],
        name: [],
        missionContent: "",
      };
    },
    htmlToPdf(
      category_name,
      channel_name,
      company_name,
      created_at,
      sign_url,
      sign_type,
      fullname,
      id_number,
      channel_taxpayer,
      id
    ) {
      if (["tomato", "esign"].includes(sign_type)) {
        this.mxPreview(sign_url);
      } else {
        let path = "/customer/exportpdf";
        let routeData = this.$router.resolve({
          path,
          query: {
            category_name,
            channel_name,
            company_name,
            created_at,
            sign_url,
            sign_type,
            fullname,
            id_number,
            channel_taxpayer,
            id,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    //复选框选择时间
    handleTaskChange(val) {
      if (val) {
        this.isCheck = false;
        this.categoryList.find((value) => {
          this.companyFormData.name.forEach((item, index) => {
            if (item == value.name) {
              this.companyFormData.name[index] = value.name;
              this.companyFormData.category_id[index] = value.id;
            }
          });
        });
        this.category_Id = this.companyFormData.category_id.join("、");
        this.category_name = this.companyFormData.name.join("、");
        const { company_id, settlement_id } = this.userInfo;
        this.signUrl = encodeURI(
          `/pages/projectsign/projectsign?companyId=${company_id}&settlementId=${settlement_id}&categoryId=${this.category_Id}&categoryName=${this.category_name}&location=${this.mxDomain.location}`
        );
      }
    },
    //获取签约链接
    async cusomerLink(noOpen) {
      this.categoryList = await this.$api.getCustomerCategoryList();
      if(noOpen){
        this.outerVisible = true;
      }
    },
    //关闭内层小dialog×
    handleInnerClose() {
      this.innerVisible = false;
      this.OrImage = "";
      this.alipayOrImage = "";
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.outerVisible = false;
      this.companyFormData = {
        category_id: [],
        name: [],
        missionContent: "",
      };
    },
    //取消内层dialog
    innerClose() {
      this.innerVisible = false;
    },
    checkCategory() {
      // 调用组件的数据验证方法
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          if (this.companyFormData.category_id != "") {
            this.getQRCode();
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 创建二维码
    async createQrCode(id) {
      let str = "/pages/projectsign/projectsign";
      if (this.$config.domain.miniappPath) {
        str = this.$config.domain.miniappPath;
      }
      let path = `${str}?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}`;
      let args = {
        path: path,
        appId: this.mxDomain.appId,
        id: id,
      };
      let res = await this.$api.createQrcode(args);
      if (res) {
        this.OrImage = res;
      }
    },
    async getQRCode() {
      let nameList = [],
        names,
        name;
      this.companyFormData.name.forEach((item) => {
        nameList.push(item.substring(0, item.length - 2));
      });
      names = nameList.join("、");
      name = `${names}`;
      let args = {
        name,
        job_remark: this.companyFormData.job_remark,
        category_id: this.companyFormData.category_id.join("、"),
        category_name: this.companyFormData.name.join("、"),
        province: this.companyFormData.work_city[0],
        city: this.companyFormData.work_city[1],
        area: this.companyFormData.work_city[2],
        salary_type: this.companyFormData.salary_type,
        min_salary: this.companyFormData.min_salary,
        max_salary: this.companyFormData.max_salary,
        education: this.companyFormData.education || '0',
        address_detail: this.companyFormData.address_detail,
        industry_type: this.companyFormData.industry_type[this.companyFormData.industry_type.length-1],
        recruit_post: this.companyFormData.recruit_post,
        worked_num: this.companyFormData.worked_num,
      };
      let res = await this.$api.createDailyTask(args);
      if (res) {
        this.handleOuterClose()
        this.init("search");
      }
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);

      let { data, pages } = await this.$api.getDailyTaskList(searchCondition);
      data.map((item,index)=>{
        data[index].all_address = item.address+item.address_detail
      })
      if (type == "export") {
        this.loadingStaus = false;
        return data;
      } else {
        this.companyList = [];

        this.$nextTick(() => {
          this.companyList = data;
        });
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },

    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.recruit_post) {
        condition.recruit_post = this.searchCondition.recruit_post;
      }
      if (this.searchCondition.category_id) {
        condition.category_id = this.searchCondition.category_id;
      }
      if (this.searchCondition.industry_type) {
        condition.industry_type = this.searchCondition.industry_type[this.searchCondition.industry_type.length-1];
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0];
        condition.end_time = this.searchCondition.time_value[1];
      }
      return condition;
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = "正在提交中……";
      this.dialogData.loading = true;
      this.formData.company_id = this.currentCompanyId;
      let id = await this.$api.saveCompanyAttachment(this.formData);
      this.$nextTick(() => {
        this.dialogClose();
      });
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList();
        }
      });
      this.$nextTick(() => {
        this.$message.success("保存成功!");
      });
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyAttacmentForm"].validate((valid) => {
        if (valid) {
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
      this.dialogData.loading = true;
      this.formData = {};
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.init();
    this.cusomerLink(false)
    this.getDailyTaskIndustryList();
  },
};
</script>

<style lang="scss" scoped>
.qyLinkArea {
  display: flex;
  flex-direction: row;
  .linkurl {
    color: #55aaff;
    &-nodata {
      color: #999498;
    }
  }
}
.searchBtnQYLink {
  margin-left: 20px;
}
.item-mobile {
  width: 240px;
}
.mainPDF {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.mainPDF label {
  margin-bottom: 10px;
}

/deep/ .el-checkbox-group label {
  width: 180px;
}

/deep/ .el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/ .el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  height: 35px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  position: absolute;
  top: 0;
  font-size: 15px;
  width: 160px;
}

.cusomer-link-search {
  position: absolute;
  top: 0;
  left: 180px;
  font-size: 15px;
  width: 160px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 20px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.code {
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  height: 200px;
  overflow: hidden;
  &.alipay-code {
    margin-left: 30px;
    position: relative;
    .QR-code {
      position: relative;
      top: -30px;
      width: 220px;
      height: 220px;
    }
    .tips {
      position: absolute;
      bottom: 0;
    }
  }
  .tips {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}
</style>
